import React, { Component } from "react";
import Activity from "./Activity";
import axios from "axios";
import { v4 as uuid } from "uuid";
const config = require("../config.json");

export default class ActivityAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  state = {
    newActivity: {
      activityName: "",
      activityName_en: "",
      activityImage: "",
      category: "",
      priority: 0,
      activityType: "",
      points: "",
      id: uuid(),
      amountRepeatable: "",
      description: "",
      climateDescription: "",
      requirementDescription: "",
      inspirationDescription: "",
      synergyDescription: "",
      climateDescription_en: "",
      requirementDescription_en: "",
      inspirationDescription_en: "",
      synergyDescription_en: "",
      recommendationTitle: "",
      recommendationTitle_en: "",
      kgCO2: "",
      weeklySpecial: false,
      active: false,
      choices: [],
      requirements: [],
      amountOfChoices: 0,
      amountOfRequirements: 0,
      kilometerInput: false,
      recommendableActivity: false,
    },
    activities: [],
    shownActivities: [],
    activityImages: [],
    activityTypes: [],
  };

  getAnswerList = (activity) => {
    const choices = [];
    for (let i = 1; i <= activity.amountOfChoices; i++) {
      choices.push({
        text_en: activity[`answer${i}_en`],
        text_da: activity[`answer${i}_da`],
        points: parseInt(activity[`answer${i}points`]),
        kgCO2: parseFloat(activity[`answer${i}kgCO2`]),
      });
    }

    return choices;
  };

  getRequirementsList = (activity) => {
    const requirements = [];
    for (let i = 1; i <= activity.amountOfRequirements; i++) {
      requirements.push({
        text_en: activity[`requirement${i}_en`],
        text_da: activity[`requirement${i}_da`],
      });
    }

    return requirements;
  };

  handleAddActivity = async (activity, event, isCopy = false) => {
    event.preventDefault();
    try {
      const activityId = isCopy ? uuid() : activity.id || uuid();
      const recommendableActivity = this.canActivityBeRecommendable(activity)
        ? activity.recommendableActivity
        : false;
      const recommendationTitle = recommendableActivity
        ? activity.recommendationTitle
        : "";
      const recommendationTitle_en = recommendableActivity
        ? activity.recommendationTitle_en
        : "";
      const params = {
        id: activityId,
        category: activity.category,
        priority: parseInt(activity.priority),
        activityType: activity.activityType,
        activityName: activity.activityName + (isCopy ? " KOPI" : ""),
        activityName_en: activity.activityName_en,
        activityImage: activity.activityImage,
        points: parseInt(activity.points),
        amountRepeatable: parseInt(activity.amountRepeatable),
        description: activity.description,
        climateDescription: activity.climateDescription,
        requirementDescription: activity.requirementDescription,
        inspirationDescription: activity.inspirationDescription,
        synergyDescription: activity.synergyDescription,
        climateDescription_en: activity.climateDescription_en,
        requirementDescription_en: activity.requirementDescription_en,
        inspirationDescription_en: activity.inspirationDescription_en,
        synergyDescription_en: activity.synergyDescription_en,
        recommendationTitle,
        recommendationTitle_en,
        kgCO2: Number(activity.kgCO2),
        weeklySpecial: activity.weeklySpecial,
        active: activity.active,
        choices: isCopy ? activity.choices : this.getAnswerList(activity),
        requirements: isCopy
          ? activity.requirements
          : this.getRequirementsList(activity),
        kilometerInput: activity.kilometerInput,
        recommendableActivity,
      };
      await axios.post(
        `${config.api.invokeUrl}/activities/${activityId}`,
        params
      );
      const addedActivity = {
        ...activity,
        id: activityId,
        activityName: activity.activityName + (isCopy ? " KOPI" : ""),
        recommendableActivity,
        recommendationTitle,
        recommendationTitle_en,
      };
      this.setState({
        activities: [...this.state.activities, addedActivity],
        shownActivities: [...this.state.shownActivities, addedActivity],
      });
      this.setState({
        newActivity: {
          activityName: "",
          activityName_en: "",
          activityImage: "",
          category: "",
          priority: 0,
          activityType: "",
          points: "",
          amountRepeatable: "",
          description: "",
          climateDescription: "",
          requirementDescription: "",
          inspirationDescription: "",
          synergyDescription: "",
          climateDescription_en: "",
          requirementDescription_en: "",
          inspirationDescription_en: "",
          synergyDescription_en: "",
          recommendationTitle: "",
          recommendationTitle_en: "",
          kgCO2: "",
          weeklySpecial: false,
          active: false,
          amountOfChoices: 0,
          amountOfRequirements: 0,
          choices: [],
          requirements: [],
          kilometerInput: false,
          recommendableActivity: false,
          id: uuid(),
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateActivity = async (activity) => {
    try {
      const recommendableActivity = this.canActivityBeRecommendable(activity)
        ? activity.recommendableActivity
        : false;
      const params = {
        id: activity.id,
        category: activity.category,
        priority: parseInt(activity.priority),
        activityType: activity.activityType,
        activityName: activity.activityName,
        activityName_en: activity.activityName_en,
        activityImage: activity.activityImage ? activity.activityImage : "",
        points: parseInt(activity.points),
        amountRepeatable: parseInt(activity.amountRepeatable),
        description: activity.description,
        climateDescription: activity.climateDescription,
        requirementDescription: activity.requirementDescription,
        inspirationDescription: activity.inspirationDescription,
        synergyDescription: activity.synergyDescription,
        climateDescription_en: activity.climateDescription_en,
        requirementDescription_en: activity.requirementDescription_en,
        inspirationDescription_en: activity.inspirationDescription_en,
        synergyDescription_en: activity.synergyDescription_en,
        recommendationTitle: recommendableActivity
          ? activity.recommendationTitle
          : "",
        recommendationTitle_en: recommendableActivity
          ? activity.recommendationTitle_en
          : "",
        kgCO2: Number(activity.kgCO2),
        weeklySpecial: activity.weeklySpecial,
        active: activity.active,
        choices: this.getAnswerList(activity),
        requirements: this.getRequirementsList(activity),
        kilometerInput: activity.kilometerInput
          ? activity.kilometerInput
          : false,
        recommendableActivity,
      };

      await axios.patch(
        `${config.api.invokeUrl}/activities/${activity.id}`,
        params
      );
    } catch (err) {
      console.log(err);
    }
    const recommendableActivity = this.canActivityBeRecommendable(activity)
      ? activity.recommendableActivity
      : false;
    const normalizedActivity = {
      ...activity,
      recommendableActivity,
      recommendationTitle: recommendableActivity
        ? activity.recommendationTitle
        : "",
      recommendationTitle_en: recommendableActivity
        ? activity.recommendationTitle_en
        : "",
    };
    const updatedActivities = [...this.state.activities].filter(
      (a) => a.id !== activity.id
    );
    updatedActivities.push(normalizedActivity);
    const updatedShownActivities = [...this.state.shownActivities].filter(
      (a) => a.id !== activity.id
    );
    updatedShownActivities.push(normalizedActivity);
    this.setState({
      activities: updatedActivities,
      shownActivities: updatedShownActivities,
    });
  };

  handleDeleteActivity = async (id, event) => {
    event.preventDefault();
    if (
      window.confirm("Dette vil slette aktiviteten for evigt. Er du sikker?")
    ) {
      try {
        await axios.delete(`${config.api.invokeUrl}/activities/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedActivities = [...this.state.activities].filter(
        (activity) => activity.id !== id
      );
      const updatedShownActivities = [...this.state.shownActivities].filter(
        (activity) => activity.id !== id
      );
      this.setState({
        activities: updatedActivities,
        shownActivities: updatedShownActivities,
      });
    }
  };

  fetchActivities = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/activities`);
      const activities = res.data;

      const activityTypes = [];

      activities.forEach((activity) => {
        if (!activityTypes.includes(activity.activityType)) {
          activityTypes.push(activity.activityType);
        }
      });

      this.setState({
        shownActivities: activities,
        activities: activities,
        activityTypes,
      });
    } catch (err) {
      console.log(err);
    }
  };

  fetchActivitiyImages = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/images?bucketName=${config.s3.activityImagesBucket}`
      );
      if (res.data?.Contents) {
        const activityImages = res.data.Contents;
        this.setState({ activityImages });
      }
    } catch (err) {
      console.log(err);
    }
  };

  filterActivities = (activityType, activities) => {
    if (activityType) {
      return activities.filter((a) => a.activityType == activityType);
    } else return activities;
  };

  canActivityBeRecommendable = (activity) =>
    parseInt(activity.amountOfChoices ?? activity.choices?.length ?? 0) > 0;

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    const newActivity = {
      ...this.state.newActivity,
      [name]: value,
    };

    if (
      name === "amountOfChoices" &&
      !this.canActivityBeRecommendable(newActivity)
    ) {
      newActivity.recommendableActivity = false;
      newActivity.recommendationTitle = "";
      newActivity.recommendationTitle_en = "";
    }

    if (name === "recommendableActivity" && !value) {
      newActivity.recommendationTitle = "";
      newActivity.recommendationTitle_en = "";
    }

    this.setState({
      newActivity,
    });
  }

  componentDidMount = () => {
    this.fetchActivitiyImages();
    this.fetchActivities();
  };

  render() {
    return (
      <>
        <p className="subtitle is-5">Tilføj og fjern aktiviteter</p>
        <br />
        <div className="columns is-multiline">
          <div className="column is-half">
            <form
              onSubmit={(event) =>
                this.handleAddActivity(this.state.newActivity, event)
              }
            >
              <div className="field">
                <div className="control">
                  Kategori:
                  <select
                    name="category"
                    value={this.state.newActivity.category}
                    onChange={this.handleInputChange}
                  >
                    <option value=""></option>
                    <option value="Ting og sager">Ting og sager</option>
                    <option value="El og varme">El og varme</option>
                    <option value="Fødevarer">Fødevarer</option>
                    <option value="Transport">Transport</option>
                    <option value="Engagement">Engagement</option>
                    <option value="Mandag">Mandag</option>
                    <option value="Tirsdag">Tirsdag</option>
                    <option value="Onsdag">Onsdag</option>
                    <option value="Torsdag">Torsdag</option>
                    <option value="Fredag">Fredag</option>
                  </select>
                </div>

                <div className="control">
                  <label htmlFor="activityActive">Aktiv: {"  "}</label>
                  <input
                    name="active"
                    id="activityActive"
                    className="is-medium"
                    type="checkbox"
                    checked={this.state.newActivity.active}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <label htmlFor="weeklySpecial">Ugens special: {"  "}</label>
                  <input
                    name="weeklySpecial"
                    id="weeklySpecial"
                    className="is-medium"
                    type="checkbox"
                    checked={this.state.newActivity.weeklySpecial}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <label htmlFor="kilometerInput">
                    Kilometer vælger: {"  "}
                  </label>
                  <input
                    name="kilometerInput"
                    id="kilometerInput"
                    className="is-medium"
                    type="checkbox"
                    checked={this.state.newActivity.kilometerInput}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  Billede:
                  <select
                    name="activityImage"
                    value={this.state.newActivity.activityImage}
                    onChange={this.handleInputChange}
                  >
                    <option value=""></option>
                    {this.state.activityImages.map((activityImage) => {
                      return (
                        <option
                          key={activityImage.Key}
                          value={activityImage.Key}
                        >
                          {activityImage.Key}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="control">
                  <input
                    name="activityName"
                    className="input is-medium"
                    type="text"
                    placeholder="Indtast navn"
                    value={this.state.newActivity.activityName}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    name="activityName_en"
                    className="input is-medium"
                    type="text"
                    placeholder="Indtast navn (engelsk)"
                    value={this.state.newActivity.activityName_en}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    name="activityType"
                    className="input is-medium"
                    type="text"
                    placeholder="Indtast type"
                    value={this.state.newActivity.activityType}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div
                  style={{ border: "1px solid #dbdbdb", padding: 5 }}
                  className="control"
                >
                  Point:
                  <input
                    name="points"
                    className="input is-medium"
                    type="text"
                    placeholder="Indtast point"
                    value={this.state.newActivity.points}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  Prioritet (0 er lavest)
                  <input
                    name="priority"
                    className="input is-medium"
                    type="number"
                    placeholder="Indtast prioritet"
                    value={this.state.newActivity.priority}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  Antal svarmuligheder
                  <input
                    className="input is-medium"
                    name={"amountOfChoices"}
                    type="number"
                    value={this.state.newActivity.amountOfChoices}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <label htmlFor="recommendableActivity">
                    Anbefalingsaktivitet: {"  "}
                  </label>
                  <input
                    name="recommendableActivity"
                    id="recommendableActivity"
                    className="is-medium"
                    type="checkbox"
                    checked={
                      this.canActivityBeRecommendable(this.state.newActivity) &&
                      this.state.newActivity.recommendableActivity
                    }
                    disabled={
                      !this.canActivityBeRecommendable(this.state.newActivity)
                    }
                    onChange={this.handleInputChange}
                  />
                  {!this.canActivityBeRecommendable(this.state.newActivity) && (
                    <p>Kræver mindst én svarmulighed.</p>
                  )}
                </div>

                {this.state.newActivity.recommendableActivity && (
                  <>
                    <div className="control">
                      <input
                        name="recommendationTitle"
                        className="input is-medium"
                        type="text"
                        placeholder="Titel til anbefalingsmodal"
                        value={this.state.newActivity.recommendationTitle}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="control">
                      <input
                        name="recommendationTitle_en"
                        className="input is-medium"
                        type="text"
                        placeholder="Titel til anbefalingsmodal (engelsk)"
                        value={this.state.newActivity.recommendationTitle_en}
                        onChange={this.handleInputChange}
                      />
                    </div>
                  </>
                )}
                {Array.from(
                  { length: parseInt(this.state.newActivity.amountOfChoices) },
                  (_, index) => index + 1
                ).map((idx) => {
                  return (
                    <div key={`answer${idx}`}>
                      Svarmulighed {idx}
                      <div className="control">
                        <input
                          className="input is-medium"
                          name={`answer${idx}_da`}
                          type="text"
                          placeholder={`Indtast svarmulighed ${idx} (DANSK)`}
                          value={this.state.newActivity[`answer${idx}_da`]}
                          onChange={this.handleInputChange}
                        />
                        <input
                          className="input is-medium"
                          name={`answer${idx}_en`}
                          type="text"
                          placeholder={`Indtast svarmulighed ${idx} (ENGELSK)`}
                          value={this.state.newActivity[`answer${idx}_en`]}
                          onChange={this.handleInputChange}
                        />
                        <input
                          className="input is-medium"
                          name={`answer${idx}points`}
                          type="text"
                          placeholder={`Indtast point`}
                          value={this.state.newActivity[`answer${idx}points`]}
                          onChange={this.handleInputChange}
                        />
                        <input
                          className="input is-medium"
                          name={`answer${idx}kgCO2`}
                          type="text"
                          placeholder={`Indtast kg CO2`}
                          value={this.state.newActivity[`answer${idx}kgCO2`]}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <br />
                    </div>
                  );
                })}

                <div className="control">
                  Antal krav
                  <input
                    className="input is-medium"
                    name={"amountOfRequirements"}
                    type="number"
                    value={this.state.newActivity.amountOfRequirements}
                    onChange={this.handleInputChange}
                  />
                </div>

                {Array.from(
                  {
                    length: parseInt(
                      this.state.newActivity.amountOfRequirements
                    ),
                  },
                  (_, index) => index + 1
                ).map((idx) => {
                  return (
                    <div key={`requirement${idx}`}>
                      Krav {idx}
                      <div className="control">
                        <input
                          className="input is-medium"
                          name={`requirement${idx}_da`}
                          type="text"
                          placeholder={`Indtast krav ${idx} (DANSK)`}
                          value={this.state.newActivity[`requirement${idx}_da`]}
                          onChange={this.handleInputChange}
                        />
                        <input
                          className="input is-medium"
                          name={`requirement${idx}_en`}
                          type="text"
                          placeholder={`Indtast krav ${idx} (ENGELSK)`}
                          value={this.state.newActivity[`requirement${idx}_en`]}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <br />
                    </div>
                  );
                })}

                <div className="control">
                  <input
                    name="amountRepeatable"
                    className="input is-medium"
                    type="text"
                    placeholder="Antal gentagelig"
                    value={this.state.newActivity.amountRepeatable}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="control">
                  <input
                    name="kgCO2"
                    className="input is-medium"
                    type="text"
                    placeholder="Indtast KG CO2 (brug punktum til kommatal fx 2.5)"
                    value={this.state.newActivity.kgCO2}
                    onChange={this.handleInputChange}
                  />
                </div>
                <textarea
                  name="description"
                  className="textarea"
                  placeholder="Indtast kort beskrivelse"
                  value={this.state.newActivity.description}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="requirementDescription"
                  className="textarea"
                  placeholder="Krav"
                  value={this.state.newActivity.requirementDescription}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="climateDescription"
                  className="textarea"
                  placeholder="Klima"
                  value={this.state.newActivity.climateDescription}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="inspirationDescription"
                  className="textarea"
                  placeholder="Inspiration"
                  value={this.state.newActivity.inspirationDescription}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="synergyDescription"
                  className="textarea"
                  placeholder="Synergi"
                  value={this.state.newActivity.synergyDescription}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="requirementDescription_en"
                  className="textarea"
                  placeholder="Krav (engelsk)"
                  value={this.state.newActivity.requirementDescription_en}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="climateDescription_en"
                  className="textarea"
                  placeholder="Klima (engelsk)"
                  value={this.state.newActivity.climateDescription_en}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="inspirationDescription_en"
                  className="textarea"
                  placeholder="Inspiration (engelsk)"
                  value={this.state.newActivity.inspirationDescription_en}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="synergyDescription_en"
                  className="textarea"
                  placeholder="Synergi (engelsk)"
                  value={this.state.newActivity.synergyDescription_en}
                  onChange={this.handleInputChange}
                />
                <div className="control">
                  <button type="submit" className="button is-primary is-medium">
                    Tilføj
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="control">
            <div>Sortering</div>
            <select
              className="select is-medium"
              name="activityTypes"
              id="activityTypes"
              onChange={() => {
                const select = document.getElementById("activityTypes");
                const filteredActivities = this.filterActivities(
                  select.options[select.selectedIndex].value,
                  this.state.activities
                );
                this.setState({ shownActivities: filteredActivities });
              }}
            >
              <option key={1} value={""}>
                Alle
              </option>
              {this.state.activityTypes.map((activityType) => {
                return (
                  <option key={activityType} value={activityType}>
                    {activityType}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="is-centered is-multiline">
          {this.state.shownActivities.map((activity) => (
            <Activity
              handleUpdateActivity={this.handleUpdateActivity}
              handleDeleteActivity={this.handleDeleteActivity}
              handleAddActivity={this.handleAddActivity}
              activity={activity}
              activityImages={this.state.activityImages}
              key={activity.id}
              isAdmin={true}
            />
          ))}
        </div>
      </>
    );
  }
}
